<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    :width="$vuetify.breakpoint.mdAndDown ? '95%' : '80%'"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="readOnly"
    :isTextButton="isTextButton"
    :textButton="textButton"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry" 
        :extraData="extraData"
        :readOnly="readOnly"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null
    };
  },
  props: {
    entry: Object,
    // readTitle: {
    //   type: String,
    //   default: "Visualização de Planejamento"
    // },
    readOnly: {
      type: Boolean,
      default: false
    },
    isTextButton: {
      type: Boolean,
      default: false
    },
    textButton: {
      type: String,
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(id) {
      // console.log("LOAD Ground", id);
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_PLANNING_OPERATION_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.editableEntry = response.data.groundContext.planningOperation;
          // console.log("planningOperation", this.editableEntry)
          // console.log(this.entry.addressAttributes, this.entry.addressAttributes == null, response.data.accountContext.address)
          // if (this.editableEntry.addressAttributes == null) {
          //   this.editableEntry.addressAttributes = response.data.accountContext.address;
          //   // console.log(this.entry.addressAttributes);
          // }
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    updateServerEntry: function(planningOperation) {
      // console.log("Edit GROUND", ground, this.editableEntry)
      // console.log("GROUND", ground, this.editableEntry.validations, this.deepFilterEntryWithAllowedFieldsForMutation(ground, this.editableEntry.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: UPDATE_PLANNING_OPERATION_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(planningOperation, this.editableEntry.validations)
          }
        })
        .then(response => {
          var errors = response.data.updatePlanningOperation.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
            this.resetForm();
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.updateServerEntry(this.editableEntry)
        this.resetForm();
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_PLANNING_OPERATION_QUERY = gql `
  query ($id: ID!) {
    groundContext {
      planningOperation(id: $id) {
        id
        operationTypeId
        operationType {
          id
          name
          kind
        }
        periodIds
        periodIdsAttribute
        periods {
          id
          name
          area
          additionalInfo
          secondAdditionalInfo
        }
        operationDate
        observation
        activitiesAttributes {
          id
          personId
          person {
            id
            name
          }
          durationInHours
          durationInMinutes
          durationText
          startDate
          endDate
          patrimonyId
          patrimony {
            id
            description
          }
          implementId
          implement {
            id
            description
          }
        }
        dummyExitMovementItemsAttributes {
          id
          itemId
          item {
            id
            name
            unit {
              id
              name
            }
            brand {
              id
              name
            }
          }
          packagingId
          packaging {
            id
            name
          }
          storageId
          storage {
            id
            name
          }
          quantity
          unitPrice
          price
          hasCropLimit
          unitQuantity
        }
        dummyEntryMovementItemsAttributes {
          id
         	itemId
          item {
            id
            name
            unit {
              id
              name
            }
          }
          quantity
          expectedUnitPrice
          price
          storageId
          storage {
            id
            name
          }
          validations
        }
        validations
      }
    }
    accountGlobalSharedContext {
      allOperationTypes {
        id
        name
        operationOrder
        kind
      }
    }
  }
`;

const UPDATE_PLANNING_OPERATION_MUTATION = gql `
  mutation($input: PlanningOperationUpdateInputObject!) {
    updatePlanningOperation(input: $input) {
      operation {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
